module.exports = __webpack_public_path__ + "static/media/celu.d2593490.jpg";